import React, { useEffect, useState } from "react";
import axios from "axios";
import logo from "../../images/footer-logo.png";

const Footer = (props) => {
    const [resources, setResources] = useState({});
    const currentYear = new Date().getFullYear();

    useEffect(() => {
        requestResources();
    }, [props.language]);

    const requestResources = () => {
        axios.get(`form/resources/${props.language}`).then((res) => {
            setResources(res.data);
        });
    };

    return (
        <footer className="footer">
            <div className="footer-top-border"></div>
            <div className="footer-content container page-container">
                <div className="row">
                    <div className="footer-columns">
                        {/* Column 1: Standorte */}
                        <div className="footer-column">
                            <a href="https://www.luks.ch/standorte" className="footer-column-title-link" target="_blank" rel="noopener noreferrer">
                                <h3 className="footer-column-title">Standorte</h3>
                            </a>
                            <ul className="footer-links">
                                <li><a href="https://www.luks.ch/standorte/standort-luzern" target="_blank" rel="noopener noreferrer">Luzern</a></li>
                                <li><a href="https://www.luks.ch/standorte/standort-sursee" target="_blank" rel="noopener noreferrer">Sursee</a></li>
                                <li><a href="https://www.luks.ch/standorte/standort-wolhusen" target="_blank" rel="noopener noreferrer">Wolhusen</a></li>
                            </ul>
                        </div>

                        {/* Column 2: Über das LUKS */}
                        <div className="footer-column">
                            <a href="https://www.luks.ch/ihr-luks" className="footer-column-title-link" target="_blank" rel="noopener noreferrer">
                                <h3 className="footer-column-title">Über das LUKS</h3>
                            </a>
                            <ul className="footer-links">
                                <li><a href="https://www.luks.ch/ihr-luks/das-unternehmen" target="_blank" rel="noopener noreferrer">Porträt und Zahlen</a></li>
                                <li><a href="https://www.luks.ch/newsroom" target="_blank" rel="noopener noreferrer">Newsroom</a></li>
                                <li><a href="https://www.luks.ch/ihr-luks/auf-instagram-mitarbeitenden-ueber-die-schulter-schauen" target="_blank" rel="noopener noreferrer">Hinter den Kulissen</a></li>
                                <li><a href="https://www.luks.ch/ihr-luks/reglemente" target="_blank" rel="noopener noreferrer">Reglemente</a></li>
                            </ul>
                        </div>

                        {/* Column 3: Stellen und Karriere */}
                        <div className="footer-column">
                            <a href="https://www.luks.ch/stellen-und-karriere" className="footer-column-title-link" target="_blank" rel="noopener noreferrer">
                                <h3 className="footer-column-title">Stellen und Karriere</h3>
                            </a>
                            <ul className="footer-links">
                                <li><a href="https://www.luks.ch/stellen-und-karriere/offene-stellen" target="_blank" rel="noopener noreferrer">Offene Stellen</a></li>
                                <li><a href="https://www.luks.ch/ausbildung" target="_blank" rel="noopener noreferrer">Ausbildung</a></li>
                            </ul>
                        </div>

                        {/* Column 4: Kontakt */}
                        <div className="footer-column">
                            <a href="https://www.luks.ch/ihr-luks/kontakt" className="footer-column-title-link" target="_blank" rel="noopener noreferrer">
                                <h3 className="footer-column-title">Kontakt</h3>
                            </a>
                            <ul className="footer-links">
                                <li><a href="https://www.luks.ch/informationen-fuer-zuweisende" target="_blank" rel="noopener noreferrer">Informationen für Zuweisende</a></li>
                                <li><a href="https://www.luks.ch/ihr-luks/medien" target="_blank" rel="noopener noreferrer">Medien</a></li>
                                <li><a href="https://www.luks.ch/veranstaltungen" target="_blank" rel="noopener noreferrer">Veranstaltungen</a></li>
                            </ul>
                        </div>
                    </div>

                    {/* Logo and Tagline Section */}
                    <div className="footer-bottom-section">
                        <div className="footer-logo-container">
                            <a href="https://www.luks.ch/" target="_blank" rel="noopener noreferrer">
                                <img src={logo} alt="Luzerner Kantonsspital" className="footer-logo" />
                            </a>
                        </div>
                        <div className="footer-tagline">
                            <div className="tagline-first-line">Universitäres Lehr- und Forschungsspital</div>
                            <span className="tag-line-divisor">|</span> 
                            <div className="tagline-second-line">
                                herzlich, kompetent, vernetzt
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-copyright-container">
                <div className="footer-copyright">
                    <div className="footer-legal-links">
                        <span>© {currentYear} Luzerner Kantonsspital</span>
                        <b><a href="https://www.luks.ch/disclaimer" target="_blank" rel="noopener noreferrer">Disclaimer</a></b>
                        <b><a href="https://www.luks.ch/impressum" target="_blank" rel="noopener noreferrer">Impressum</a></b>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
